import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SecondaryControlButton from '../../../../../../../services/prints/components/PrintProductConfigurator/components/PrintProductConfiguratorControlsPane/SecondaryControlButton';
import {
  CARD_ELEMENT_TYPE,
  ORIENTATION,
} from '../../../../../../../services/cards/constants';
import { getCardPhotoSlots } from './helpers';
import SecondaryControlButtonSizeRectangle from '../../../../../../../services/prints/components/PrintProductConfigurator/components/PrintProductConfiguratorControlsPane/SecondaryControlButton/SecondaryControlButtonSizeRectangle';

const propTypes = {
  className: PropTypes.string,
  cardPrintSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  cardOrientation: PropTypes.oneOf(Object.values(ORIENTATION)).isRequired,
  onCardElementCreate: PropTypes.func.isRequired,
  zElementIndexMax: PropTypes.number,
};

const CardDesignerPhotoControls = ({
  className,
  cardPrintSize,
  cardOrientation,
  onCardElementCreate,
  zElementIndexMax,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  const cardPhotoSlots = useMemo(
    () => getCardPhotoSlots({ cardPrintSize, cardOrientation }),
    [cardPrintSize],
  );

  return (
    <div className={classes}>
      <div className="card-designer-layout-controls-list card-designer-layout-photo-controls-list">
        {cardPhotoSlots.map(photoSlot => {
          return (
            <SecondaryControlButton
              key={photoSlot.label}
              className="is-lg"
              title={photoSlot.label}
              icon={
                <SecondaryControlButtonSizeRectangle
                  width={photoSlot.width}
                  height={photoSlot.height}
                  orientation={photoSlot.orientation}
                  className="rounded"
                />
              }
              onClick={() => {
                onCardElementCreate({
                  cardElementConfiguration: {
                    is_editable: true,
                  },
                  cardElementType: CARD_ELEMENT_TYPE.PHOTO,
                  input: {
                    ...photoSlot.input,
                    z_index: zElementIndexMax ?? 1,
                  },
                });
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

CardDesignerPhotoControls.propTypes = propTypes;

export default CardDesignerPhotoControls;
